import { CompanyKeywordDto, CompanyKeywordUpdateRequest } from '../models/api/companyKeywordDto';
import { KeywordType } from '../models/enums/keywordType.enum';

export interface KeywordFieldMapping {
  formField: string;
  type: KeywordType;
}

/**
 * Builds the keyword upsert payload from a keywords form-group value.
 *
 * A keyword is included when it has a value OR when a keyword of that type
 * already exists on the company. The latter is what lets a user *clear* a
 * keyword: the now-empty field is still sent (as ''), so the backend overwrites
 * the stored value. Fields that are empty and were never stored are skipped, so
 * untouched fields don't create empty rows.
 */
export function buildKeywordRequests(
  keywordsValue: Record<string, unknown> | null | undefined,
  mapping: KeywordFieldMapping[],
  existing: CompanyKeywordDto[]
): CompanyKeywordUpdateRequest[] {
  const requests: CompanyKeywordUpdateRequest[] = [];
  for (const m of mapping) {
    const raw = keywordsValue?.[m.formField];
    const value = raw == null ? '' : String(raw);
    if (value || existing.some(k => k.type === m.type)) {
      requests.push({ type: m.type, value });
    }
  }
  return requests;
}
